import { useTable, useTableActions } from "../TableContext";
import { useTableFiltering } from "./useTableFiltering";
import { useTablePagination } from "./useTablePagination";
import { useTableSearch } from "./useTableSearch";
import { useTableSelection } from "./useTableSelection";
import { useTableSort } from "./useTableSort";

/**
 * Hook combiné pour avoir tout ce dont on a besoin
 */
export const useTableComplete = <T extends { id: string | number }>() => {
  const { state } = useTable();
  const actions = useTableActions();
  const pagination = useTablePagination();
  const selection = useTableSelection<T>();
  const sort = useTableSort();
  const search = useTableSearch();
  const filtering = useTableFiltering();

  return {
    // State
    data: state.data as T[],
    loading: state.loading,
    error: state.error,

    // Modules
    pagination,
    selection,
    sort,
    search,
    filtering,

    // Actions directes
    actions,

    // Refresh manuel
    refresh: actions.fetchDataAsync
  };
};
